var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveMyPageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20C3 18.4087 3.63214 16.8826 4.75736 15.7574C5.88258 14.6321 7.4087 14 9 14H15C16.5913 14 18.1174 14.6321 19.2426 15.7574C20.3679 16.8826 21 18.4087 21 20ZM12 12C12.9889 12 13.9556 11.7068 14.7779 11.1573C15.6001 10.6079 16.241 9.82705 16.6194 8.91342C16.9978 7.99979 17.0969 6.99446 16.9039 6.02455C16.711 5.05465 16.2348 4.16373 15.5355 3.46447C14.8363 2.76521 13.9454 2.289 12.9755 2.09608C12.0055 1.90315 11.0002 2.00217 10.0866 2.3806C9.17295 2.75904 8.39206 3.39991 7.84265 4.22215C7.29324 5.0444 7 6.0111 7 7C7 8.32609 7.52678 9.59785 8.46447 10.5355C9.40215 11.4732 10.6739 12 12 12Z",
    fill: "#2BB1E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveMyPageIcon);
export default __webpack_public_path__ + "static/media/active-myPage-icon.77cec2b89da150812ffb135d1f9c43d8.svg";
export { ForwardRef as ReactComponent };